(function($) {

	function pick_order_return(e){
		e.preventDefault()

		let $form = $(this);

		let url = ghostpress_params.ajax_url + "&action=pick_order_return",
			data = $form.serializeArray()

		$(".notices_ajax_login").empty()

		gp_ajax({
			url: url,
			type: "post",
			dataType: "json",
			show_loading: true,
			data: data
		})
		.done((response, textStatus, jqXHR) => {
		})
	}
	$('.pick-order-return-form').on('submit', pick_order_return)
})(jQuery);